import '../scss/app.scss';
import './navigation';
import './swiper';
import './wine-tabs';
import './awards-collapse';